import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, FormControl, FormGroup } from "react-bootstrap";
import { WIDGET_NAME } from "../../constants";
import SettingTabWrapper from "../../components/SettingTabWrapper";
import CommonSettings from "../SettingsTabs/CommonSettings";
import MemberInfo from "../SettingsTabs/MemberInfo";
import MemberPopup from "../SettingsTabs/MemberPopup";

const SettingsSidebar = ({
    eventPassword,
    eventKey,
    eventSettings,
    isSaving,
    onSaveModel,
    onUpdateModel,
}) => {
    const history = useHistory();
    const [model, setModel] = useState(null);

    return (
        <FormGroup>
            <FormGroup style={{display: 'flex', columnGap: '12px'}}>
                <Button
                    bsStyle="primary"
                    disabled={isSaving}
                    onClick={onSaveModel}
                >
                    Сохранить
                </Button>
                <Button
                    disabled={isSaving}
                    onClick={() => history.push(`/event/${eventPassword}/widgets/members`)}
                >
                    Закрыть
                </Button>
            </FormGroup>

            <FormGroup>
                <FormControl
                    type="text"
                    placeholder="Введите название виджета"
                    maxLength={50}
                    defaultValue={eventSettings?.[WIDGET_NAME] || ''}
                    onChange={(e) => setModel({...model, [WIDGET_NAME]: e.target.value})}
                    onBlur={(e) => onUpdateModel({[WIDGET_NAME]: e.target.value})}
                />
            </FormGroup>

            <FormGroup>
                <SettingTabWrapper
                    title="Общие настройки"
                    label="commonSettings"
                >
                    <CommonSettings
                        eventKey={eventKey}
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title="Подписи"
                    label="memberInfo"
                >
                    <MemberInfo
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
                <SettingTabWrapper
                    title={'Вид поп-ап "Профайл участника"'}
                    label="memberPopup"
                >
                    <MemberPopup
                        settings={eventSettings}
                        onChange={onUpdateModel}
                    />
                </SettingTabWrapper>
            </FormGroup>
        </FormGroup>
    );
};

export default SettingsSidebar;
